import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";
import {
  deleteMeetingThreadAction,
  meetingChatWithResponsesAction,
} from "../redux/actions";
import { selectMeetingsThread, selectMeetingValue } from "../redux/selectors";
import { addUserMessage } from "../redux/slice";
import { ChangeEvent, useCallback, useState } from "react";

export const useMeetingsChat = () => {
  const dispatch = useAppDispatch();
  const value = useAppSelector(selectMeetingValue);
  const thread_ref = useAppSelector(selectMeetingsThread);
  const [message, setMessage] = useState<string>("");

  const handleChangeMessage = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(event.target.value);
  };

  const handleSendMessage = useCallback(() => {
    if (message.trim() === "") return;
    if (!value?.meetings_object) {
      return;
    }
    dispatch(addUserMessage(message));
    dispatch(meetingChatWithResponsesAction(message));
    setMessage("");
  }, [message, dispatch]);

  const handleSendKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (event.ctrlKey && event.key === "Enter") {
        event.preventDefault();
        handleSendMessage();
      }
    },
    [message, dispatch],
  );

  const handleClearChat = () => {
    if (!thread_ref) return;
    dispatch(deleteMeetingThreadAction(thread_ref as string));
  };

  return {
    message,
    handleChangeMessage,
    handleSendKeyDown,
    handleSendMessage,
    handleClearChat,
  };
};
